import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationStart, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ProblemModel } from 'src/app/store/problem/model';
import { OrderFacade } from 'src/app/store/order/facade';
import { OrderModel } from 'src/app/store/order/model';
import { ModeInfoPanelEnum } from 'src/app/core/enums/mode-info-panel-enum';
import { ProblemForUserFacade } from 'src/app/store/problem-user/facade';
import { DialogQRCodeLinkComponent } from '../../dialogs/dialog-qrcode-link/dialog-qrcode-link.component';
import { MessengerConstants } from 'src/app/core/constants/messenger-constants';
//import * as introJs from 'intro.js/intro.js';
import serviceCatalogRu from '../../../../assets/i18n/introRu.json';
import serviceCatalogUk from '../../../../assets/i18n/introUk.json';
import { AppConstants } from 'src/app/core/constants/app-constants';

@Component({
  selector: 'app-info-panel',
  templateUrl: './info-panel.component.html',
  styleUrls: ['./info-panel.component.scss'],
  host: {
    class: 'app-info-panel',
  },
  standalone: false,
})
export class InfoPanelComponent implements OnInit {
  private router = inject(Router);
  translate = inject(TranslateService);
  private problemForUserFacade = inject(ProblemForUserFacade);
  private orderFacade = inject(OrderFacade);

  @ViewChild(DialogQRCodeLinkComponent) dialogQRCodeLink: DialogQRCodeLinkComponent;

  selfDiagnosticServiceCatalogUrl: string = '/self-diagnostic/service-catalog';

  problems$: Observable<ProblemModel[]>;
  orders$: Observable<OrderModel[]>;
  opened: boolean = true;
  isDisabledInfo: boolean = true;
  //introJS = introJs();
  private nextTextButton: string;
  private prevTextButton: string;
  private doneTextButton: string;
  private modeInfoPanel: ModeInfoPanelEnum = ModeInfoPanelEnum.Info;

  ngOnInit(): void {
    this.problems$ = this.problemForUserFacade.allProblems$;
    this.orders$ = this.orderFacade.allOrders$;

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.isDisabledInfo = true;
        if (event.url === this.selfDiagnosticServiceCatalogUrl) {
          this.isDisabledInfo = false;
          const stor = JSON.parse(localStorage.getItem(event.url));

          if (!stor) {
            localStorage.setItem(event.url, JSON.stringify(true));
            this.showMasterHelpByUrl(event.url);
          }
        }
      }
    });
  }

  showProblems() {
    this.modeInfoPanel = ModeInfoPanelEnum.Problems;
  }

  goToInfoPage() {
    this.modeInfoPanel = ModeInfoPanelEnum.Info;
  }

  isInfoMode(): boolean {
    return this.modeInfoPanel === ModeInfoPanelEnum.Info;
  }

  isProblemsMode(): boolean {
    return this.modeInfoPanel === ModeInfoPanelEnum.Problems;
  }

  goToOrdersPage() {
    this.router.navigate(['/orders']);
  }

  goToStepsDiagnostic() {
    this.router.navigate(['/self-diagnostic/service-catalog']);
  }

  goToProblemPreviewPage(problem) {
    this.router.navigate(['/problem/preview', problem.id]);
  }

  openOrCloseInfoPanel() {
    this.opened = !this.opened;
  }

  showViberPanel() {
    if (this.dialogQRCodeLink) {
      this.dialogQRCodeLink
        .execute('Viber', MessengerConstants.viberUrl, '../../../../assets/images/icon-viber.svg')
        .subscribe(result => {});
    } else {
      alert('DialogQRCodeLinkComponent not found');
    }
  }

  showTitlegramPanel() {
    if (this.dialogQRCodeLink) {
      this.dialogQRCodeLink
        .execute('Telegram', MessengerConstants.telegramUrl, '../../../../assets/images/icon-telegram.svg')
        .subscribe(result => {});
    } else {
      alert('DialogQRCodeLinkComponent not found');
    }
  }

  showMasterHelp() {
    this.showMasterHelpByUrl(this.router.url);
  }

  closeMenu() {
    let infoPanel = document.querySelector('.app-info-panel'),
      navOverlay = document.querySelector('.nav-overlay'),
      burger = document.querySelector('.ic.menu');
    infoPanel.classList.remove('app-info-panel_active');
    navOverlay.classList.remove('nav-overlay_active');
    burger.classList.remove('menu_active');
  }

  showMasterHelpByUrl(url: string) {
    let introData = null;
    if (url === this.selfDiagnosticServiceCatalogUrl) {
      introData = this.translate.currentLang == AppConstants.LANGUAGE_UK ? serviceCatalogUk : serviceCatalogRu;
    }

    if (introData) {
      this.translate.get('READ_MORE').subscribe(value => {
        this.nextTextButton = value;
      });
      this.translate.get('PREV').subscribe(value => {
        this.prevTextButton = value;
      });
      this.translate.get('DONE').subscribe(value => {
        this.doneTextButton = value;
      });
      /*
      Треба розібратись на що його замінити і чи потрібно воно взагалі
      this.introJS
        .setOptions({
          steps: introData,
          nextLabel: this.nextTextButton,
          prevLabel: this.prevTextButton,
          doneLabel: this.doneTextButton,
        })
        .start();
      */
    }
  }
}
